<template>
  <div class="missing-panel">
    <button
      v-if="count > 0"
      type="button"
      class="missing-panel__trigger"
      :class="{ 'missing-panel__trigger--open': isExpanded }"
      @click="$emit('toggle')"
    >
      <svg
        class="missing-panel__arrow"
        :class="{ 'missing-panel__arrow--up': isExpanded }"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M1 4l5 5 5-5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span class="missing-panel__text">Нужно заполнить</span>
      <span class="missing-panel__badge">{{ count }}</span>
    </button>

    <div v-else class="missing-panel__done">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <circle cx="7" cy="7" r="6" stroke="#16a34a" stroke-width="1.5" />
        <path
          d="M4 7l2 2 4-4"
          stroke="#16a34a"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span class="missing-panel__text">Всё заполнено</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseMissingFieldsPanel",

  props: {
    count: {
      type: Number,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["toggle"],
};
</script>

<style scoped>
.missing-panel {
  display: flex;
  align-items: center;
}

.missing-panel__trigger {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 14px;
  background: #fff7ed;
  border: 1.5px solid #fb923c;
  border-radius: 8px;
  cursor: pointer;
  color: #9a3412;
  font-size: 13px;
  font-weight: 600;
  transition: background 0.15s, border-color 0.15s;
  white-space: nowrap;
}

.missing-panel__trigger:hover,
.missing-panel__trigger--open {
  background: #ffedd5;
  border-color: #ea580c;
}

.missing-panel__arrow {
  flex: 0 0 auto;
  color: #ea580c;
  transition: transform 0.2s ease;
}

.missing-panel__arrow--up {
  transform: rotate(180deg);
}

.missing-panel__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border-radius: 10px;
  background: #ea580c;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

.missing-panel__done {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: #f0fdf4;
  border: 1.5px solid #86efac;
  border-radius: 8px;
  color: #15803d;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

@media (max-width: 420px) {
  .missing-panel__trigger,
  .missing-panel__done {
    gap: 6px;
    padding: 8px 10px;
  }

  .missing-panel__text {
    display: none;
  }
}
</style>
